var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"loadfail"}},[_c('ctheader',{attrs:{"titles":_vm.titles,"back-btn":_vm.backBtn,"back-path":_vm.backPath}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"fail"}),_c('div',{staticClass:"fail-text"},[_vm._v(" 加载数据失败，请"),_c('span',{on:{"click":_vm.reload}},[_vm._v("刷新")]),_vm._v("试试 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }